
import { useServiceCatalog } from '@/services/useServiceCatalog'
import sectionLayoutContent from '@/components/common/section-layout-content.vue'
import Editor from '@/pages/admin/catalog/components/Editor.vue'
import DesignTemplate from '@/pages/admin/catalog/components/DesignTemplate.vue'
import Variants from '@/pages/admin/catalog/components/Variant.vue'
import UploadImage from '@/components/common/UploadImage.vue'
import { reactive, defineComponent, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import userCatalogRepositories from '@/repositories/userCatalogRepositories'
import { useFetchData } from '@/composables'

export default defineComponent({
  components: {
    sectionLayoutContent,
    Editor,
    DesignTemplate,
    UploadImage,
    Variants,
  },
  name: 'Create Catalog',
  setup() {
    const breadcrumbs = ['Catalog', 'Create Catalog']
    const content = computed(() => {
      return { breadcrumbs }
    })
    const router = useRouter()
    const resource = `/catalogs`
    const catalog = reactive<any>({
      name: '',
      type: 'pod',
      categories: [],
      productCode: '',
      description: '',
      description2: '',
      variants: [],
      mockupGallery: [],
      sizes: [],
      colors: [],
      designs: [],
      production: '',
      shipping: '',
      material: '',
    })
    const changeDescription = (html: string, dataSet: any) => {
      dataSet.description = html
    }
    const changeDescription2 = (html: string, dataSet: any) => {
      dataSet.description2 = html
    }
    const params = reactive({})
    const { documents, fetchData } = useFetchData(`/catalog-categories`, params)
    fetchData()
    const addDesign = (data: any, dataSet: any, status: any) => {
      if (status.index > -1) {
        dataSet.splice(status.index, 1, data)
      } else {
        dataSet.push(data)
      }
    }
    const callbackMockup = (setData: any, files: string[]) => {
      console.log('files', files)
      setData.mockupGallery = files
    }
    const changeProduction = (html: string, dataSet: any) => {
      dataSet.production = html
    }
    const changeShipping = (html: string, dataSet: any) => {
      dataSet.shipping = html
    }
    const changeMaterial = (html: string, dataSet: any) => {
      dataSet.material = html
    }
    const costBy = ref<string>('color')
    const changeCostBy = (value: string) => {
      costBy.value = value
    }
    const delDesign = (index: number) => {
      catalog.designs.splice(index, 1)
    }
    const isSubmit = ref<boolean>(false)
    const catalogForm = ref<any>(null)
    const addCatalog = async () => {
      isSubmit.value = true
      catalogForm.value?.validate(async (valid: any) => {
        const { addCatalog } = userCatalogRepositories()
        let { status, data } = await addCatalog(catalog)
        if (status === 201) {
          router.push({
            name: 'a.catalog-detail',
            params: { id: data._doc._id },
          })
        }
        // if (valid && catalog.colors.length > 0 && catalog.sizes.length > 0 && catalog.variants.length > 0 && catalog.designs.length > 0) {
        //   const { addCatalog } = userCatalogRepositories();
        //   let  { status, data } = await addCatalog(catalog)
        //   if (status === 201) {
        //     router.push({ name: 'a.catalog-detail', params: { id: data._doc._id}})
        //   }
        //   console.log('status', status)
        // }
      })
    }
    const callbackVariant = (
      colors: any[],
      sizes: any[],
      variants: any[],
      deleteVariants?: any[]
    ) => {
      catalog.colors = colors
      catalog.sizes = sizes
      catalog.variants = variants
    }

    const discard = () => {
      Object.assign(catalog, {
        name: '',
        categories: '',
        productCode: '',
        description: '',
        description2: '',
        variants: [],
        mockupGallery: [],
        sizes: [],
        colors: [],
        designs: [],
        production: '',
        shipping: '',
        material: '',
      })
    }

    const deleteCatalog = () => {
      router.push({ name: 'a.catalogs' })
    }
    const rulesCatalog = {
      name: [
        {
          required: true,
          message: 'Please input name',
          trigger: 'blur',
        },
      ],
      categories: [
        {
          required: true,
          message: 'Please input category',
          trigger: 'blur',
        },
      ],
      productCode: [
        {
          required: true,
          message: 'Please input product code',
          trigger: 'blur',
        },
      ],
    }
    return {
      useServiceCatalog,
      resource,
      content,
      catalog,
      changeDescription,
      changeDescription2,
      addDesign,
      callbackMockup,
      changeProduction,
      changeShipping,
      changeMaterial,
      changeCostBy,
      delDesign,
      addCatalog,
      costBy,
      callbackVariant,
      router,
      discard,
      deleteCatalog,
      rulesCatalog,
      catalogForm,
      isSubmit,
      documents,
    }
  },
})
